var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification',{attrs:{"is-read":_vm.isRead,"created-at":_vm.createdAt},on:{"click":_vm.handleClick}},[_c('h2',{staticClass:"truncate"},[_vm._v("Paniers")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.notification.data.carts.length > 1 ? 'Des paniers vont bientôt expirer.' : 'Un panier va bientôt expirer.'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }